import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function TooltipRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()
  const tooltipText = element.text ? String(resolveSymbol(element.text) ?? "") : ""

  const trigger = element.children?.[0]

  return (
    <TooltipPrimitive.Provider>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <div className={cn("inline-block", element.className)} data-testid={`tooltip-${element.id}`}>
            {trigger && <ElementRenderer element={trigger} />}
          </div>
        </TooltipPrimitive.Trigger>
        {tooltipText && (
          <TooltipPrimitive.Portal>
            <TooltipPrimitive.Content
              className="z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
              sideOffset={4}
            >
              {tooltipText}
            </TooltipPrimitive.Content>
          </TooltipPrimitive.Portal>
        )}
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  )
}
